import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import JobFunctionsChecklist from './JobFunctionsChecklist';
import BasicInfoForm from './BasicInfoForm';
import WeeklyBooking from './WeeklyBooking';
import PaymentDetails from './PaymentDetails';
import { PriceSetter } from './market-maker-v2';
import Plumbers from './market-maker-v2/components/Plumbers';
import TradeUI from './market-maker-v2/components/TradeUI';

import { getAuth, setPersistence, browserLocalPersistence, onAuthStateChanged } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { setUser } from './store/userSlice';

//Import Mixpanel SDK
import mixpanel from "mixpanel-browser";
 
// Near entry of your product, init Mixpanel
mixpanel.init("9b33af7b4c9a565a314d78a61d65c419", {
  debug: true,
  track_pageview: true,
  persistence: "localStorage",
});

export const mixpanelTrack = (eventName, properties) => {
  mixpanel.track(eventName, properties);
};

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyD2tfkaIO_y9msGoTcyX7KILiXNIEtkD3o",
  authDomain: "microbushel.firebaseapp.com",
  projectId: "microbushel",
  appId: "962723481008",
};

const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

function App() {
  const [showForm, setShowForm] = useState(false);
  const [showBooking, setShowBooking] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [showPriceSetter, setShowPriceSetter] = useState(true);
  const [showPlumbers, setShowPlumbers] = useState(false);
  const [showTradeUI, setShowTradeUI] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {

    setPersistence(auth, browserLocalPersistence)
      .then(() => {
        console.log("Persistence set to browserLocalPersistence");
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        console.error("Error setting persistence:", errorCode, errorMessage);
      });

    onAuthStateChanged(auth, (user) => {
    if (user) {
      // User is signed in
      console.log("User is signed in:", user);
      dispatch(setUser(user));


    } else {
      console.log("No user is signed in.");
      dispatch(setUser(null));
      // dispatch(setDisplayedComponent("home"));
      // User is signed out
    }
  });

  }, [dispatch]);

  if (showForm) {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', padding: 40 }}>
        <button onClick={() => setShowForm(false)} style={{ marginBottom: 24, background: '#eee', border: 'none', borderRadius: 4, padding: '8px 16px', cursor: 'pointer' }}>
          ← Back
        </button>
        <BasicInfoForm />
      </div>
    );
  }

  if (showBooking) {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', padding: 40 }}>
        <button onClick={() => setShowBooking(false)} style={{ marginBottom: 24, background: '#eee', border: 'none', borderRadius: 4, padding: '8px 16px', cursor: 'pointer' }}>
          ← Back
        </button>
        <WeeklyBooking />
      </div>
    );
  }

  if (showPayment) {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', padding: 40 }}>
        <button onClick={() => setShowPayment(false)} style={{ marginBottom: 24, background: '#eee', border: 'none', borderRadius: 4, padding: '8px 16px', cursor: 'pointer' }}>
          ← Back
        </button>
        <PaymentDetails />
      </div>
    );
  }

  if (showPriceSetter) {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', padding: 40 }}>
        {/* <button onClick={() => setShowPriceSetter(false)} style={{ marginBottom: 24, background: '#eee', border: 'none', borderRadius: 4, padding: '8px 16px', cursor: 'pointer' }}>
          ← Back
        </button> */}
        <PriceSetter />
      </div>
    );
  }

  if (showPlumbers) {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', padding: 40 }}>
        <button onClick={() => setShowPlumbers(false)} style={{ marginBottom: 24, background: '#eee', border: 'none', borderRadius: 4, padding: '8px 16px', cursor: 'pointer' }}>
          ← Back
        </button>
        <Plumbers />
      </div>
    );
  }

  if (showTradeUI) {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', padding: 40 }}>
        <button onClick={() => setShowTradeUI(false)} style={{ marginBottom: 24, background: '#eee', border: 'none', borderRadius: 4, padding: '8px 16px', cursor: 'pointer' }}>
          ← Back
        </button>
        <TradeUI />
      </div>
    );
  }  

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: 40 }}>
      {/* <h1>Welcome to QualityCare</h1>
      <p>This is your new React app. Start building something great!</p>
      <a
        href="#basic-info-form"
        onClick={e => { e.preventDefault(); setShowForm(true); }}
        style={{ display: 'inline-block', margin: '16px 0', color: '#1976d2', textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
      >
        Go to Basic Info Form
      </a>
      <a
        href="#weekly-booking"
        onClick={e => { e.preventDefault(); setShowBooking(true); }}
        style={{ display: 'inline-block', margin: '0 0 16px 24px', color: '#1976d2', textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
      >
        Book Weekly Hours
      </a>
      <a
        href="#payment-details"
        onClick={e => { e.preventDefault(); setShowPayment(true); }}
        style={{ display: 'inline-block', margin: '0 0 16px 24px', color: '#1976d2', textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
      >
        Payment Details
      </a>
      <a
        href="#price-setter"
        onClick={e => { e.preventDefault(); setShowPriceSetter(true); }}
        style={{ display: 'inline-block', margin: '0 0 16px 24px', color: '#ff6f00', textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
      >
        Market Maker V2 - Entity & Order Management
      </a>
      <a
        href="#plumbers"
        onClick={e => { e.preventDefault(); setShowPlumbers(true); }}
        style={{ display: 'inline-block', margin: '0 0 16px 24px', color: '#388e3c', textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
      >
        View Plumbers
      </a>
      <a
        href="#tradeui"
        onClick={e => { e.preventDefault(); setShowTradeUI(true); }}
        style={{ display: 'inline-block', margin: '0 0 16px 24px', color: '#388e3c', textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
      >
        Trade UI
      </a>
      <JobFunctionsChecklist /> */}
    </div>
  );
}

export default App;
